module.exports = __webpack_public_path__ + "static/media/facebook-hangin-sign.a470a4d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/facebook-hangin-sign.svg
// module id = 125
// module chunks = 0